import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { ProductCustomDefinitionImageMetadata } from "../../state/product-custom-attributes/CustomAttributeDefinition"
import { NO_AVAILABLE_IMAGE_IMAGE_PATH } from "../../utils"
import { CustomAttributeSelectProps, SelectOption } from "../types"

const CustomAttributeSelect = (props: CustomAttributeSelectProps) => {  
    const valueOrElement = props.isMulti
        ? props.value
        : Array.isArray(props.value) && props.value.length > 0
            ? props.value[0]
            : ""
    const [value, setValue] = useState(valueOrElement)
    const hasImages = props.customAttribute.metadata?.some(item => item.images && item.images.length > 0)
    const getImageUrl = (imageArray: ProductCustomDefinitionImageMetadata) => {
        if (imageArray.images && imageArray.images.length > 0) {
            return imageArray.images[0].attributes.publicUrl
        }
        return NO_AVAILABLE_IMAGE_IMAGE_PATH
    }
    
    const selectOptions: SelectOption<string | JSX.Element>[] = props.customAttribute.metadata?.map(o => ({
        value: o.id,
        label: <div className="d-inline-flex align-items-center justify-content-center align-middle" style={{minHeight:"24px"}} >
            {hasImages 
                ? getImageUrl(o) !== "" 
                    && <img src={getImageUrl(o)} style={{maxHeight: "25px", maxWidth:"25px"}} />
                : <></>
            }
            <div style={{marginLeft:"10px"}}> {o.label} </div>
        </div>,
        filterElement:o.label,
    }))

    const defaultValue = selectOptions[0]?.value
    const filterOption = (option, searchText) => {
        if (option?.filterElement?.toLowerCase().includes(searchText.toLowerCase())) {
            return true
        }
        return false
    }


    return (<>
        <Select
            value={value}
            onChange={(value) => {
                let item=value
                if (!Array.isArray(value)) {
                    item=[value]
                }
                setValue(value)
                if (props.onChangeCallback) {
                    props.onChangeCallback(item)
                }
            }}
            multi={props.isMulti}
            filterOption={(option, searchText)=>filterOption(option, searchText)}
            defaultValue={defaultValue}
            options={selectOptions}
        />
    </>)

}

export default injectIntl(CustomAttributeSelect)



// WEBPACK FOOTER //
// ./src/common/form/CustomAttributeSelect.tsx